module.exports = __webpack_public_path__ + "static/history01_03-aa6a9e3583c55ba6dec489dfd26d97aa.png";